<main>
    <div class="container-fluid mb-4 fondo-gris-ok" style="margin-top:-20px;">
        <div class="container">
            <div class="row">
                <div class="col-md-7 col-12 mt-3">
                    <h1>Reporte Consolidado de Cursos</h1>
                </div>
                <div class="col-md-5 col-12">
                    <div aria-label="breadcrumb" class="text-right float-right">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href={{urlGestion}}>Home</a></li>
                            <li class="breadcrumb-item"><a [routerLink]="['/home-reportes']">Reportes</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Reporte Consolidado de Cursos</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="col-12 form-group">
                    <div class="row">
                        <div class="col-12" style="margin-bottom: 25px;">
                            <label>Selecciona una o varias Empresas y/o Sucursales y el Período a consultar, luego presiona la tecla Enter o el botón con el icono de Lupa:</label>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-12 col-md-5 col-lg-6">
                            <app-selector-empresa [empresas]="empresas" (seleccionEmpresas)="seleccionarEmpresasSucursales($event)"></app-selector-empresa>
                        </div>
                        <div class="col-12 col-md-5 col-lg-6">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4 form-group">
                                    <label>Fecha Inicio Desde:</label>
                                    <kendo-datepicker class="form-control" placeholder="Ingresa" [(ngModel)]="fecIni" (valueChange)="configuraFechas()" [disabled]="empresasSucursalSeleccionadas.length === 0 || sinPVs" [min]="min" [max]="max" (keydown)="filtrarReporteKeydown($event)">
                                        <kendo-datepicker-messages today="Hoy">
                                        </kendo-datepicker-messages>
                                    </kendo-datepicker>
                                    <!-- <kendo-combobox [data]="listFecIni" [(ngModel)]="fecIni" (valueChange)="configuraFechas()" [disabled]="empresasSucursalSeleccionadas.length === 0 || sinPVs" [suggest]="true" class="form-control" placeholder="Selecciona el Año" (keydown)="filtrarReporteKeydown($event)">
                                    </kendo-combobox> -->
                                    <span *ngIf="errorFiltro.fecIni" class="form-error">
                                      Debes seleccionar Fecha Desde
                                  </span>
                                </div>

                                <div class="col-12 col-md-6 col-lg-4 form-group">
                                    <label>Fecha Término Hasta:</label>
                                    <kendo-datepicker class="form-control" placeholder="Ingresa" [(ngModel)]="fecFin" (valueChange)="configuraFechas()" [disabled]="empresasSucursalSeleccionadas.length === 0 || sinPVs" [min]="min" [max]="max" [disabled]="true" (keydown)="filtrarReporteKeydown($event)">
                                        <kendo-datepicker-messages today="Hoy">
                                        </kendo-datepicker-messages>
                                    </kendo-datepicker>
                                    <!-- <kendo-combobox [data]="listFecFin" [(ngModel)]="fecFin" (valueChange)="configuraFechas()" [disabled]="empresasSucursalSeleccionadas.length === 0 || sinPVs" [suggest]="true" class="form-control" placeholder="Selecciona el Año" (keydown)="filtrarReporteKeydown($event)">
                                    </kendo-combobox> -->
                                    <span *ngIf="errorFiltro.fecFin" class="form-error">
                                      Debes seleccionar Fecha Hasta
                                  </span>
                                </div>

                                <div class="col-12 col-md-2 form-group mt-1">
                                    <a *ngIf="permisosModulosAcciones.REPCUR.acciones.includes('REPCUR_Acceder')" (click)="filtrarReporte()" data-toggle="tooltip" ngbTooltip="Descargar Reporte" class="btn btn-primary" style="margin-top:20px;">
                                        <img src="../assets/img/busca.png" class="icon-md">
                                    </a>
                                </div>

                                <div class="col-12 form-group">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <span>&nbsp;&nbsp;Mostrar en el Reporte:</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 form-group">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input style="outline: 1px solid #000000" type="checkbox" id="checkAnulados" class="k-checkbox" [(ngModel)]="checkAnulados"/>
                                            <span>&nbsp;&nbsp;Acciones de Capacitación y Participantes anulados.</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 form-group">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input style="outline: 1px solid #000000" type="checkbox" id="checkAnulados" class="k-checkbox" [(ngModel)]="checkCASeparados"/>
                                            <span>&nbsp;&nbsp;Campos Adicionales con Código y Descripción separado en columnas.</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 form-group">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input style="outline: 1px solid #000000" type="checkbox" id="checkAnulados" class="k-checkbox" [(ngModel)]="checkCASoloCC"/>
                                            <span>&nbsp;&nbsp;Campos Adicionales pertenecientes al Cliente Comercial.</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>